import type { ComponentProps } from 'react';

function Done(props: ComponentProps<'svg'>) {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx={12} cy={12} r={12} fill="#10B981" fillOpacity={0.08} />
      <path d="M7.5 11.77 10.73 15l6-6" stroke="#10B981" strokeWidth={1.5} strokeLinecap="round" />
    </svg>
  );
}
export default Done;
